import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ComboCliente, ComboTipoServicio } from '../../core/model/combos';
import { ContenidosPendientes } from '../../core/model/contenido-pendiente';
import { ColaTrabajoOCR } from '../../core/model/ocr';
import { Page } from '../../core/model/page';
import { IPagination } from '../../core/model/pagination';
import { ResizedEvent } from '../../core/model/resized-event';
import { Solicitudes, SolicitudesSearch } from '../../core/model/solicitudes';
import { AlbaranService } from '../../core/services/albaran.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ClientesService } from '../../core/services/clientes.service';
import { ContenidosService } from '../../core/services/contenidos.service';
import { OCRService } from '../../core/services/ocr.service';
import { PopulateService } from '../../core/services/populate.service';
import { SolicitudesService } from '../../core/services/solicitudes.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';
import { ResultadoBusquedaSolicitudes } from './../../core/model/resultado-busqueda-solicitudes';
import { Statistics } from '../../core/model/cliente';
import { ModalConfirmationComponent } from '../../utils/modal-confirmation/modal-confirmation.component';
import { UsersService } from '../../core/services/users.service';
import { VideoInicialComponent } from '../video-inicial/video-inicial.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    providers: [SolicitudesService]
})

export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('table') table: DatatableComponent;
    @ViewChild('tableContenidos') tableContenidos: DatatableComponent;
    @ViewChild('tableTrabajosOCR') tableTrabajosOCR: DatatableComponent;

    Title: string;
    Description: string;
    Padre: string;
    Hijo: string;

    private subscription;
    private subscription_change;
    private subscription_sol;
    private subscription_rol;

    isDocoutUser: boolean;
    isSupervisor = false;
    statusCode: number;
    requestProcessingSol = false;
    noHaySolicitudes = false;
    mensajeToShow: string;
    tableColumns: any[] = [];

    contenidosPendientes = new ContenidosPendientes();


    fecha_ultimo_acceso: Date;

    // Modelos formulario
    allSolicitudes: Solicitudes[];
    solicitudesSearch: SolicitudesSearch = new SolicitudesSearch();

    statistics: Statistics;

    // ngx-datatable options
    customMessages = {
        emptyMessage: 'No hay solicitudes disponibles',
        totalMessage: 'Total',
        selectedMessage: 'Selección'
    };

    customClasses = {
        sortAscending: 'fas fa-sort-up',
        sortDescending: 'fas fa-sort-down',
        pagerLeftArrow: 'fas fa-chevron-left',
        pagerRightArrow: 'fas fa-chevron-right',
        pagerPrevious: 'fas fa-step-backward',
        pagerNext: 'fas fa-step-forward'
    };

    pageNumber = 0;
    pageSize = 10;
    sortField = 'id';
    sortDirection = 'desc';
    trabajosOCR: ColaTrabajoOCR[];

    clienteSeleccionado = undefined;
    servicioSeleccionado = undefined;

    filterForm = new FormGroup({
        cliente: new FormControl(this.clienteSeleccionado),
        servicio: new FormControl(this.servicioSeleccionado)
    });

    clientes: ComboCliente[] = [];
    tiposServicio: ComboTipoServicio[] = [];
    thinking = false;
    reloadOCRJobs = false;

    page = new Page();
    modalRef: BsModalRef = undefined;
    qrText = '';
    qrValidText: boolean = undefined;
    qrThinking = false;

    constructor(
        private translateService: TranslateService,
        private authService: AuthenticationService,
        private solicitudeservice: SolicitudesService,
        private toastr: ToastrService,
        private utilservice: UtilitiesService,
        private router: Router,
        private contenidosService: ContenidosService,
        private populateService: PopulateService,
        private ocrService: OCRService,
        private modalService: BsModalService,
        private albaranService: AlbaranService,
        private clienteService: ClientesService,
        private activatedRoute: ActivatedRoute,
        private modalservice: BsModalService,
        private usersService: UsersService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 10;

        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {

            const popupMessage = localStorage.getItem('popupMessageDashboard');
            if (!!popupMessage) {
                this.showConfirmationModal(popupMessage);
            }
            localStorage.removeItem('popupMessageDashboard');
        });

    }

    ngOnInit() {
        this.SetEnviroment();
        this.initTableColumns();
    }

    ngAfterViewInit() {
        // 🥑🥑 llamo video inicial
        if (!this.usersService.videoInicialMostrado) {
            this.preCargaModalVideoInicial();
        }
    }

    ngOnDestroy() {
        if (this.subscription != null) { this.subscription.unsubscribe(); }
        if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
        if (this.subscription_sol != null) { this.subscription_sol.unsubscribe(); }
        if (this.subscription_rol != null) { this.subscription_rol.unsubscribe(); }

        this.translateService = null;
        this.authService = null;
        this.toastr = null;
        this.solicitudeservice = null;
        this.router = null;
    }


    private initTableColumns() {
        this.tableColumns = [
            { name: this.translateService.instant('solicitudes.columns.Id'), prop: 'Id' },
            { name: this.translateService.instant('solicitudes.columns.Client'), prop: 'NOMBRE_CLIENTE' },
            { name: this.translateService.instant('solicitudes.columns.Applicant'), prop: 'USUARIO' },
            { name: this.translateService.instant('solicitudes.columns.Type'), prop: 'TIPO' },
            { name: this.translateService.instant('solicitudes.columns.Priority'), prop: 'PRIORIDAD' },
            { name: this.translateService.instant('solicitudes.columns.State'), prop: 'ESTADO_DESCRIPCION' },
            { name: this.translateService.instant('solicitudes.columns.Situation'), prop: 'SITUACION_DESCRIPCION' },
            { name: this.translateService.instant('solicitudes.columns.InitDate'), prop: 'FECHA_ALTA' },
            { name: this.translateService.instant('solicitudes.columns.LimitDate'), prop: 'FECHA_LIMITE' },
            { name: this.translateService.instant('solicitudes.columns.LastDate'), prop: 'FECHA_FIN' }
        ];
    }


    SetEnviroment() {
        this.subscription_rol = this.authService.isSupervisorUserObs().subscribe(supervisor => {
            this.authService.isAdminUserObs().subscribe(admin => {
                this.isSupervisor = supervisor === true || admin === true;
            });
        });

        this.authService.getClienteName$().subscribe(beadcrumbDad => {
            this.Padre = beadcrumbDad;
        });

        this.authService.getDateLastVisited().subscribe(lastdate => {
            this.fecha_ultimo_acceso = lastdate;
        });

        this.authService.isDocOutUser()
            .then((isDocUser: boolean) => {
                this.isDocoutUser = isDocUser;
                if (this.isDocoutUser) {
                    this.getStatisticDocout();
                    this.getClientes();
                    this.getContenidosPendientes(true);
                    this.getOCRJobs();
                } else {
                    this.getStatisticClient();
                    this.getAllSolicitudes();
                }
            });

        // recogemos y mostramos la fecha de la última visita para mostrar nueva información desde el último acceso.
    }
    private getStatisticDocout(): any {
        this.clienteService.getStatisticDocout()
            .subscribe((statistics: Statistics) => {
                this.statistics = statistics;
            });
    }
    private getStatisticClient(): any {
        this.clienteService.getStatisticClient()
            .subscribe((statistics: Statistics) => {
                this.statistics = statistics;
            });
    }

    getClientes() {
        this.populateService.getComboCliente()
            .subscribe(
                clientes => {
                    this.clientes = clientes.sort(function (a, b) {
                        if (a.NOMBRE < b.NOMBRE) { return -1; }
                        if (a.NOMBRE > b.NOMBRE) { return 1; }
                        return 0;
                    });
                },
                error => {
                    this.statusCode = 500;
                    this.subscription = this.translateService.get(['mensajes'])
                        .subscribe(values => {
                            this.toastr.warning(values['mensajes']['nodata'],
                                values['mensajes']['nodatatitle']);
                        });
                });
    }

    onClientChange() {
        this.clienteSeleccionado = +this.clienteSeleccionado;
        this.servicioSeleccionado = undefined;
        this.tiposServicio = [];

        if (this.clienteSeleccionado && this.clienteSeleccionado > -1) {
            this.getTipoServicioByCliente();
        }
    }

    getTipoServicioByCliente() {
        this.populateService.getComboTipoServicioByCliente(this.clienteSeleccionado)
            .subscribe(
                tiposservicio => {
                    this.tiposServicio = tiposservicio.sort(function (a, b) {
                        if (a.NOMBRE < b.NOMBRE) { return -1; }
                        if (a.NOMBRE > b.NOMBRE) { return 1; }
                        return 0;
                    });
                },
                errorCode => {
                    this.statusCode = 500; // errorCode
                    this.subscription = this.translateService.get(['mensajes'])
                        .subscribe(values => {
                            this.toastr.warning(values['mensajes']['nodata'],
                                values['mensajes']['nodatatitle']);
                        });
                });
    }

    // endregion

    // region "Datatable ultimas solicitudes"

    viewDetail(identificador: string) {
        this.router.navigate(['docout', { outlets: { contenido: ['detalle', identificador] } }]);
    }


    getAllSolicitudes() {
        this.thinking = true;
        this.preProcessSolicitudes('Cargando solicitudes... Espere por favor.');
        this.solicitudesSearch.ID_USUARIO = 0;
        this.subscription_sol = this.solicitudeservice.getAllSolicitudes(this.solicitudesSearch, 0, 15)
            .subscribe((result: ResultadoBusquedaSolicitudes) => {
                this.thinking = false;
                this.allSolicitudes = new Array();
                this.allSolicitudes = result.subconjuntoSolicitudes;
                this.noHaySolicitudes = !result || result.totalSolicitudes === 0;
                this.requestProcessingSol = false;
            },
                errorCode => {
                    this.thinking = false;
                    this.statusCode = 500; // errorCode
                    this.noHaySolicitudes = true;
                    this.subscription = this.translateService.get(['mensajes'])
                        .subscribe(values => {
                            this.toastr.warning(values['mensajes']['nosolicitudes'],
                                values['mensajes']['nosolicitudestitle']);
                        });
                });
    }

    onResized(event: ResizedEvent): void {
        if (this.table !== undefined && this.table._rows !== undefined) {
            setTimeout(() => {
                this.table.recalculate();
                window.dispatchEvent(new Event('resize'));
            }, (50));
        }
    }

    onResizedContenidos(event: ResizedEvent): void {
        if (this.tableContenidos !== undefined && this.tableContenidos._rows !== undefined) {
            setTimeout(() => {
                this.tableContenidos.recalculate();
                window.dispatchEvent(new Event('resize'));
            }, (50));
        }
    }

    onResizedOCR(event: ResizedEvent): void {
        if (this.tableTrabajosOCR !== undefined && this.tableTrabajosOCR._rows !== undefined) {
            setTimeout(() => {
                this.tableTrabajosOCR.recalculate();
                window.dispatchEvent(new Event('resize'));
            }, (50));
        }
    }

    // endregion


    preProcessSolicitudes(mensaje: string) {
        this.statusCode = null;
        this.requestProcessingSol = true;
        this.mensajeToShow = mensaje;
    }



    exportData() {
        const csv = this.generateCSVFromRequets();

        const fileName = this.translateService.instant('solicitudes.solicitudes') + '.csv';

        this.utilservice.downloadDataInCSV(fileName, csv);
    }

    private generateCSVFromRequets(): string {
        const columns = this.getColumnsForUser();
        let csvString = this.convertValuesToCSVRow(columns.map(column => column.name));
        this.allSolicitudes.forEach(value => {
            csvString += this.convertValuesToCSVRow(columns.map(column => this.getData(column.prop, value)));
        });
        return csvString;
    }

    private getColumnsForUser(): any[] {
        const columns: any[] = [];
        this.tableColumns.forEach(column => {
            if ((column.prop == 'USUARIO' && (this.isDocoutUser || this.isSupervisor))
                || column.prop != 'NOMBRE_CLIENTE' || this.isDocoutUser) {
                columns.push(column);
            }
        });
        return columns;
    }

    private getData(prop: string, data: any): string {
        if (prop == 'PRIORIDAD') {
            const keyTranslate = data[prop] == 0 ? 'generales.normal' : 'generales.urgente';
            return this.translateService.instant(keyTranslate);
        }
        return data[prop];
    }

    private convertValuesToCSVRow(values: any[]): string {
        return values.join(';') + '\n';
    }

    getOCRJobs(resetPage?: boolean) {
        this.reloadOCRJobs = true;
        if (resetPage) {
            this.page.pageNumber = 0;
        }

        const inicio = this.page.size * this.page.pageNumber;
        const fin = inicio + (+this.page.size);

        this.ocrService.getOCRJobs(inicio, fin).subscribe((data: IPagination<ColaTrabajoOCR>) => {
            this.trabajosOCR = data.dataList;
            this.page.totalElements = data.totalResults;
            this.reloadOCRJobs = false;
        });
    }

    getContenidosPendientes(reset: boolean) {
        this.thinking = true;
        if (reset) {
            this.pageNumber = 0;
        }
        const inicio = this.pageSize * this.pageNumber;
        const fin = inicio + (this.pageSize);
        this.contenidosService.getContenidosPendientes(this.clienteSeleccionado, +this.servicioSeleccionado,
            this.sortField, this.sortDirection === 'asc', inicio, fin)
            .subscribe((contenidos: ContenidosPendientes) => {
                this.thinking = false;
                this.contenidosPendientes = contenidos;
            },
                error => {
                    this.thinking = false;
                    this.toastr.error('Se ha producido un error obteniendo los contenidos pendientes');
                });
    }

    setPage(pageInfo: any) {
        this.pageNumber = pageInfo.offset;
        this.getContenidosPendientes(false);
    }

    setPageOCR(pageInfo: any) {
        this.page.pageNumber = pageInfo.offset;
        this.getOCRJobs();
    }

    setSort(sortInfo: any) {
        this.sortDirection = sortInfo.sorts[0].dir;
        this.sortField = sortInfo.sorts[0].prop;
        this.getContenidosPendientes(true);
    }

    showQRModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    comprobarQR() {
        const tmp = this.qrText;
        setTimeout(() => {
            if (tmp === this.qrText) {
                this.qrThinking = true;
                this.albaranService.checkQRText(this.qrText).subscribe((result: number) => {
                    this.qrThinking = false;
                    this.qrValidText = true;
                    setTimeout(() => {
                        this.modalRef.hide();
                        this.viewDetail('' + result);
                    }, 1000);
                },
                    error => {
                        this.qrValidText = false;
                        this.qrThinking = false;
                    });
            }
        }, 500);
    }

    private showConfirmationModal(message: string): void {
        const modal = this.modalService.show(ModalConfirmationComponent);
        (<ModalConfirmationComponent>modal.content).showConfirmationModal(
            this.translateService.instant('mensajes.nopermissionAction'),
            message,
            '',
            this.translateService.instant('generales.ok'),
            null,
            true,
            'fas fa-exclamation-triangle fa-3x text-yellow',
            'bg-yellow'
        );
    }

    // 🥑🥑 Sabes si cargo modal del video inicial
    preCargaModalVideoInicial() {
        this.usersService.getMostrarVideoInicial()
            .subscribe(
                (resultadoBusqueda) => {
                    if (resultadoBusqueda === 0) {
                        this.showModalVideoInicial();
                        this.usersService.videoInicialMostrado = true;
                    }
                },
                (e: Error) => {
                    this.toastr.error('No se ha podido recuperar el parametro VIDEO_INICIAL del usuario');
                }
            );
    }

    // 🥑🥑 Carga modal del video inicial
    showModalVideoInicial() {
        const modal = this.modalservice.show(VideoInicialComponent, { backdrop: 'static', keyboard: false, class: 'modal-lg' });
        (<VideoInicialComponent>modal.content).onSaveCambios.subscribe(datos => {
            if (datos) {
                this.usersService.changeParamVideoInicial().subscribe(resultadoAct => {
                    if (!resultadoAct) {
                        this.toastr.warning('No se ha podido actualizar el parametro VIDEO_INICIAL del usuario.');
                    } else {
                        this.toastr.info('No se volverá a mostrar el video inicial.');
                    }
                },
                    (err: HttpErrorResponse) => {
                        this.toastr.error('No se ha podido actualizar el dato del video inicial.');
                        this.thinking = false;
                    }
                );
            }

        });


    }

}
